(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-ccp-style-sets]';
  var productCache = {};

  function loadProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    productCache[handle] = fetch(root + 'products/' + handle + '.js', {
      headers: { 'Accept': 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to load product ' + handle + '.');
      return response.json();
    }).catch(function () { return null; });
    return productCache[handle];
  }

  function unique(values) {
    return values.filter(function (value, index, list) {
      return value && list.indexOf(value) === index;
    });
  }

  function variantOption(variant, index) {
    if (!variant) return '';
    if (Array.isArray(variant.options)) return variant.options[index] || '';
    return variant['option' + (index + 1)] || '';
  }

  function optionNames(product) {
    if (!product) return [];
    if (Array.isArray(product.options)) {
      return product.options.map(function (option) {
        return typeof option === 'string' ? option : option.name;
      });
    }
    if (Array.isArray(product.options_with_values)) {
      return product.options_with_values.map(function (option) { return option.name; });
    }
    return [];
  }

  function normalizedValue(value) {
    return String(value || '').trim().toLowerCase().replace(/[\s_-]+/g, ' ');
  }

  function canonicalColor(value) {
    var normalized = normalizedValue(value);
    var aliases = {
      'taupe': 'taupe', 'greige': 'taupe', 'グレージュ': 'taupe', 'トープ': 'taupe',
      'black': 'black', 'ブラック': 'black', '黒': 'black',
      'beige': 'beige', 'ベージュ': 'beige',
      'light pink': 'light pink', 'ライトピンク': 'light pink', '淡いピンク': 'light pink',
      'mocha': 'mocha', 'モカ': 'mocha',
      'orange': 'orange', 'オレンジ': 'orange'
    };
    return aliases[normalized] || normalized;
  }

  function imageUrl(variant, product) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (variant && variant.featured_media && variant.featured_media.preview_image) return variant.featured_media.preview_image.src;
    if (product && product.featured_image) {
      return typeof product.featured_image === 'string' ? product.featured_image : product.featured_image.src;
    }
    return '';
  }

  function productUrl(product) {
    if (!product || !product.handle) return '#';
    var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
    return root + 'products/' + product.handle;
  }

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(Number(cents || 0), window.theme.moneyFormat);
    }
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function StyleSets(root) {
    this.root = root;
    this.tabs = Array.prototype.slice.call(root.querySelectorAll('[data-style-tab]'));
    this.groups = Array.prototype.slice.call(root.querySelectorAll('[data-style-group]'));
    this.dialog = root.querySelector('[data-style-dialog]');
    this.dialogOptions = root.querySelector('[data-dialog-options]');
    this.dialogTitle = root.querySelector('[data-dialog-title]');
    this.activeIndex = Math.max(0, this.tabs.findIndex(function (tab) { return tab.classList.contains('is-active'); }));
    this.timer = null;
    this.dialogCard = null;
    this.init();
  }

  StyleSets.prototype.init = function () {
    var self = this;
    this.root.dataset.ccpStyleSetsInitialized = 'true';

    this.tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () {
        self.setActive(index, true);
      });
    });

    this.groups.forEach(function (group) {
      self.initGroup(group);
    });

    this.root.addEventListener('click', function (event) {
      var changeButton = event.target.closest('[data-change-product]');
      var bundleButton = event.target.closest('[data-add-complete-set]');
      var quickBuyButton = event.target.closest('[data-quick-buy]');
      var disabledQuickBuy = event.target.closest('[data-quick-buy].is-disabled');
      if (disabledQuickBuy) {
        event.preventDefault();
        return;
      }
      if (quickBuyButton) {
        event.preventDefault();
        self.addSingleProduct(quickBuyButton.closest('[data-style-card]'), quickBuyButton);
        return;
      }
      if (changeButton) self.openAlternatives(changeButton.closest('[data-style-card]'));
      if (bundleButton) self.addCompleteSet(bundleButton.closest('[data-style-group]'), bundleButton);
    });

    if (this.dialog) {
      var closeButton = this.dialog.querySelector('[data-dialog-close]');
      if (closeButton) closeButton.addEventListener('click', function () { self.closeDialog(); });
      this.dialog.addEventListener('close', function () { self.startAutoplay(); });
      this.dialog.addEventListener('click', function (event) {
        if (event.target === self.dialog) self.closeDialog();
      });
    }

    this.root.addEventListener('mouseenter', function () { self.stopAutoplay(); });
    this.root.addEventListener('mouseleave', function () { self.startAutoplay(); });
    this.root.addEventListener('focusin', function () { self.stopAutoplay(); });
    this.root.addEventListener('focusout', function () { self.startAutoplay(); });
    this.startAutoplay();
  };

  StyleSets.prototype.setActive = function (index, userInitiated) {
    if (!this.groups.length) return;
    this.activeIndex = (index + this.groups.length) % this.groups.length;
    var transition = this.root.dataset.transition || 'fade';

    this.tabs.forEach(function (tab, tabIndex) {
      var active = tabIndex === this.activeIndex;
      tab.classList.toggle('is-active', active);
      tab.setAttribute('aria-selected', active ? 'true' : 'false');
    }, this);

    this.groups.forEach(function (group, groupIndex) {
      var active = groupIndex === this.activeIndex;
      group.hidden = !active;
      group.classList.toggle('is-active', active);
      group.dataset.transition = transition;
      if (active) {
        group.classList.remove('is-entering');
        window.requestAnimationFrame(function () { group.classList.add('is-entering'); });
      }
    }, this);

    if (userInitiated) {
      this.stopAutoplay();
      this.startAutoplay();
    }
  };

  StyleSets.prototype.initGroup = function (group) {
    var self = this;
    var cards = Array.prototype.slice.call(group.querySelectorAll('[data-style-card]'));
    group._ccpCards = cards;

    cards.forEach(function (card) {
      loadProduct(card.dataset.productHandle).then(function (product) {
        if (product) self.setCardProduct(card, product, true);
      });
    });

    this.updateBundle(group);
  };

  StyleSets.prototype.getColorIndex = function (product, targetColor) {
    var names = optionNames(product);
    var variants = product && Array.isArray(product.variants) ? product.variants : [];
    var canonicalTarget = canonicalColor(targetColor);

    if (canonicalTarget) {
      var valueMatch = names.findIndex(function (_name, index) {
        return variants.some(function (variant) {
          return canonicalColor(variantOption(variant, index)) === canonicalTarget;
        });
      });
      if (valueMatch >= 0) return valueMatch;
    }

    return names.findIndex(function (name) {
      name = normalizedValue(name);
      return name.indexOf('color') >= 0 || name.indexOf('colour') >= 0 ||
        name.indexOf('カラー') >= 0 || name === '色' || name.indexOf('色') >= 0 ||
        name.indexOf('couleur') >= 0 || name.indexOf('farbe') >= 0 ||
        name.indexOf('colore') >= 0 || name.indexOf('颜色') >= 0 ||
        name.indexOf('顏色') >= 0;
    });
  };

  StyleSets.prototype.chooseVariant = function (card) {
    var product = card._ccpProduct;
    if (!product || !Array.isArray(product.variants)) return null;
    var group = card.closest('[data-style-group]');
    var targetColor = String(group ? group.dataset.styleColor || '' : '').toLowerCase();
    var colorIndex = this.getColorIndex(product, targetColor);
    var preferred = String(card.dataset.preferredVariant || '').toLowerCase();
    var selections = card._ccpSelections || {};

    function matches(variant, requireAvailability) {
      if (requireAvailability && !variant.available) return false;
      if (targetColor && colorIndex >= 0 && canonicalColor(variantOption(variant, colorIndex)) !== canonicalColor(targetColor)) return false;
      return Object.keys(selections).every(function (index) {
        return variantOption(variant, Number(index)) === selections[index];
      });
    }

    return product.variants.find(function (variant) {
      return preferred && String(variant.public_title || variant.title || '').toLowerCase() === preferred && matches(variant, true);
    }) || product.variants.find(function (variant) {
      return matches(variant, true);
    }) || product.variants.find(function (variant) {
      return matches(variant, false);
    }) || product.variants.find(function (variant) { return variant.available; }) || product.variants[0] || null;
  };

  StyleSets.prototype.buildSelectors = function (card) {
    var self = this;
    var product = card._ccpProduct;
    var holder = card.querySelector('[data-product-options]');
    if (!product || !holder) return;
    var names = optionNames(product);
    var group = card.closest('[data-style-group]');
    var targetColor = group ? group.dataset.styleColor || '' : '';
    var colorIndex = this.getColorIndex(product, targetColor);
    card._ccpSelections = {};
    holder.innerHTML = '';

    names.forEach(function (name, index) {
      if (index === colorIndex) return;
      var values = unique(product.variants.map(function (variant) { return variantOption(variant, index); }));
      if (!values.length || (values.length === 1 && values[0] === 'Default Title')) return;

      var wrap = document.createElement('div');
      wrap.className = 'ccp-style-card__option';
      var label = document.createElement('label');
      var select = document.createElement('select');
      var selectId = 'ccp-option-' + Math.random().toString(36).slice(2);
      label.htmlFor = selectId;
      label.textContent = name;
      select.id = selectId;
      values.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        select.appendChild(option);
      });
      card._ccpSelections[index] = values[0];
      select.addEventListener('change', function () {
        card._ccpSelections[index] = select.value;
        self.updateCardVariant(card);
      });
      wrap.appendChild(label);
      wrap.appendChild(select);
      holder.appendChild(wrap);
    });
  };

  StyleSets.prototype.setCardProduct = function (card, product, initial) {
    card._ccpProduct = product;
    this.buildSelectors(card);
    this.updateCardVariant(card);

    var title = card.querySelector('[data-product-title]');
    var url = productUrl(product);
    if (title) title.textContent = initial && card.dataset.titleOverride ? card.dataset.titleOverride : (product.title || title.textContent);
    card.querySelectorAll('[data-product-link], [data-product-title-link]').forEach(function (link) { link.href = url; });
    var quickBuy = card.querySelector('[data-quick-buy]');
    if (quickBuy) {
      quickBuy.href = url;
      quickBuy.dataset.handle = product.handle || '';
    }

    if (!initial) this.updateBundle(card.closest('[data-style-group]'));
  };

  StyleSets.prototype.updateCardVariant = function (card) {
    var product = card._ccpProduct;
    var variant = this.chooseVariant(card);
    card._ccpVariant = variant;
    card.classList.toggle('is-unavailable', !variant || !variant.available);

    var price = card.querySelector('[data-product-price]');
    if (price) price.innerHTML = variant ? formatMoney(variant.price) : '';

    var image = card.querySelector('[data-product-image]');
    var nextImage = imageUrl(variant, product);
    if (image && nextImage) {
      image.src = nextImage;
      image.removeAttribute('srcset');
      image.alt = product.title || image.alt;
    }

    var quickBuy = card.querySelector('[data-quick-buy]');
    if (quickBuy) {
      if (variant && variant.id) quickBuy.dataset.variantId = variant.id;
      quickBuy.setAttribute('aria-disabled', variant && variant.available ? 'false' : 'true');
      quickBuy.classList.toggle('is-disabled', !variant || !variant.available);
    }

    this.updateBundle(card.closest('[data-style-group]'));
  };

  StyleSets.prototype.updateBundle = function (group) {
    if (!group) return;
    var cards = group._ccpCards || Array.prototype.slice.call(group.querySelectorAll('[data-style-card]'));
    var required = cards.filter(function (card) { return card.dataset.includeInBundle === 'true'; });
    var included = required.filter(function (card) { return card._ccpVariant; });
    var total = included.reduce(function (sum, card) { return sum + Number(card._ccpVariant.price || 0); }, 0);
    var discount = Math.min(Number(group.dataset.discountCents || 0), total);
    var price = group.querySelector('[data-bundle-price]');
    var saving = group.querySelector('[data-bundle-saving]');
    var button = group.querySelector('[data-add-complete-set]');
    var invalid = required.length === 0 || required.some(function (card) { return !card._ccpVariant || !card._ccpVariant.available; });

    if (price) price.innerHTML = formatMoney(total - discount);
    if (saving) {
      saving.hidden = discount <= 0;
      saving.innerHTML = discount > 0 ? 'Save ' + formatMoney(discount) : '';
    }
    if (button) button.disabled = invalid;
  };

  StyleSets.prototype.openAlternatives = function (card) {
    if (!this.dialog || !this.dialogOptions || !card) return;
    var self = this;
    var alternatives = Array.prototype.slice.call(card.querySelectorAll('[data-alternative]'));
    if (!alternatives.length) return;
    this.dialogCard = card;
    this.dialogOptions.innerHTML = '';
    if (this.dialogTitle) this.dialogTitle.textContent = 'Change ' + (card.dataset.slotType || 'product');

    alternatives.forEach(function (alternative) {
      var handle = alternative.dataset.alternativeHandle;
      var sourceButton = alternative.querySelector('[data-select-alternative]');
      if (!handle || !sourceButton) return;
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'ccp-style-dialog__option';
      button.innerHTML = sourceButton.innerHTML;
      button.addEventListener('click', function () {
        button.disabled = true;
        loadProduct(handle).then(function (product) {
          if (product) self.setCardProduct(card, product, false);
          self.closeDialog();
        });
      });
      self.dialogOptions.appendChild(button);
    });

    this.stopAutoplay();
    if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
    else this.dialog.setAttribute('open', '');
  };

  StyleSets.prototype.closeDialog = function () {
    if (!this.dialog) return;
    if (typeof this.dialog.close === 'function') this.dialog.close();
    else this.dialog.removeAttribute('open');
    this.dialogCard = null;
    this.startAutoplay();
  };

  StyleSets.prototype.addSingleProduct = async function (card, button) {
    if (!card || !button || button.disabled || !card._ccpVariant || !card._ccpVariant.available) return;
    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(card._ccpVariant.id), quantity: 1 }] })
      });
      if (!response.ok) {
        var payload = await response.json().catch(function () { return {}; });
        throw new Error(payload.description || 'Unable to add this product.');
      }
      button.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:item-added', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:drawer:update', { bubbles: true }));
      window.setTimeout(function () {
        button.disabled = false;
        button.textContent = originalText;
      }, 1200);
    } catch (error) {
      button.disabled = false;
      button.textContent = originalText;
      var group = card.closest('[data-style-group]');
      var status = group && group.querySelector('[data-bundle-status]');
      if (status) status.textContent = error.message || 'Unable to add this product.';
    }
  };

  StyleSets.prototype.addCompleteSet = async function (group, button) {
    if (!group || !button) return;
    var status = group.querySelector('[data-bundle-status]');
    var cards = (group._ccpCards || []).filter(function (card) { return card.dataset.includeInBundle === 'true'; });
    var invalidCard = cards.find(function (card) { return !card._ccpVariant || !card._ccpVariant.available; });
    if (!cards.length || invalidCard) {
      if (status) status.textContent = 'Please select an available option for every item in the set.';
      return;
    }

    var originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    if (status) status.textContent = '';

    try {
      var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
      var response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: cards.map(function (card) {
            return {
              id: Number(card._ccpVariant.id),
              quantity: 1,
              properties: {
                '_Style Set': group.dataset.styleName || group.dataset.styleGroup || '',
                '_Slot': card.dataset.slotType || ''
              }
            };
          })
        })
      });
      if (!response.ok) {
        var payload = await response.json().catch(function () { return {}; });
        throw new Error(payload.description || 'Unable to add this set.');
      }
      if (status) status.textContent = 'Complete set added to cart.';
      button.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('theme:cart:added', { bubbles: true }));
      window.setTimeout(function () { window.location.href = root + 'cart'; }, 500);
    } catch (error) {
      if (status) status.textContent = error.message || 'Unable to add this set. Please try again.';
      button.disabled = false;
      button.textContent = originalText;
    }
  };

  StyleSets.prototype.startAutoplay = function () {
    var self = this;
    this.stopAutoplay();
    if (this.root.dataset.autoplay !== 'true' || this.groups.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var speed = Math.max(2000, Number(this.root.dataset.autoplaySpeed || 5000));
    this.timer = window.setInterval(function () { self.setActive(self.activeIndex + 1, false); }, speed);
  };

  StyleSets.prototype.stopAutoplay = function () {
    if (this.timer) window.clearInterval(this.timer);
    this.timer = null;
  };

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    context.querySelectorAll(ROOT_SELECTOR).forEach(function (root) {
      if (root.dataset.ccpStyleSetsInitialized !== 'true') root._ccpStyleSets = new StyleSets(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var root = event.target && event.target.closest ? event.target.closest(ROOT_SELECTOR) : null;
    if (!root || !root._ccpStyleSets) return;
    var group = event.target.closest('[data-style-group]');
    var tab = event.target.closest('[data-style-tab]');
    if (group) root._ccpStyleSets.setActive(root._ccpStyleSets.groups.indexOf(group), true);
    if (tab) root._ccpStyleSets.setActive(root._ccpStyleSets.tabs.indexOf(tab), true);
  });
})();
